<template lang="pug">
section
  .hero
    .hero-body
      .container
        h1.title Articles
        .columns.is-centered.is-multiline
          .column.is-half.is-flex(v-for="article in articles")
            .card(@click="openArticle(article.id)")
              .card-image
                figure.image
                  prismic-image(:field="article.image")
              .card-content
                .content
                  p.title.is-4 {{ article.title }}
                  p.title.is-4 {{ article.author }}
                  p.subtitle.is-6 {{ article.date }}
                  b-taglist
                    b-tag(v-for="tag in article.tags", type="is-link", rounded) {{ tag["tag"][0]["text"] }}
                  p {{ article.description }}
                  b-button(type="is-dark") Read
</template>

<script>
export default {
  name: "Articles",

  data() {
    return {
      articles: []
    };
  },

  methods: {
    // Fetch articles from Prismic
    getArticles() {
      this.$prismic.client
        .query(this.$prismic.Predicates.at("document.type", "article"), {
          orderings: "[my.article.date desc]",
          pageSize: 4
        })
        .then(response => {
          const results = response.results;
          this.articles = results.map(document => {
            return {
              id: document.id,
              title: document.data.title ? document.data.title[0].text : "",
              author: document.data.article
                ? document.data.article[0].text
                : "",
              image: document.data.image,
              date: document.data.date,
              tags: document.data.tags,
              description: document.data.description
                ? document.data.description[0].text
                : "",
              body: document.data.body
            };
          });
        });
    },

    // Open article
    openArticle(articleID) {
      this.$router.push({ path: `/article?id=${articleID}` });
    }
  },

  created() {
    this.getArticles();
  }
};
</script>

<style lang="scss" scoped>
.card {
  -webkit-filter: brightness(100%);
}

.card:hover {
  -webkit-filter: brightness(70%);
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  -o-transition: all 1s ease;
  -ms-transition: all 1s ease;
  transition: all 1s ease;
  cursor: pointer;
}
</style>
